import PaginationInputDto from '@/shared/dtos/pagination'
import { HttpService } from '@/shared/services'
import Role from '../models/Role'
import List from '@/shared/dtos/List'

const http = new HttpService()

export const getRoles = async () => {
  const response = await http.get<List<Role[]>>('role')
  return response.data
}
